import { Facility } from '..'

export const getFacilities = (): Facility[] => {
    return [
        {
            facilityId: 12345,
            facilityName: 'Facility 1',
            facilityAddress: {
                address1: '433 Hamptons, New York, NY, 10014, USA',
            },
        },
        {
            facilityId: 23456,
            facilityName: 'Facility 2',
            facilityAddress: {
                address1: '304 Cooper Street, New York, NY, 10014, USA',
            },
        },
        {
            facilityId: 34567,
            facilityName: 'Facility 3',
            facilityAddress: {
                address1: '101 Independence Street, New York, NY, 10014, USA',
            },
        },
        {
            facilityId: 45678,
            facilityName: 'Facility 4',
            facilityAddress: {
                address1: '101 Independence Street, New York, NY, 10015, USA',
            },
        },
        {
            facilityId: 56782,
            facilityName: 'Facility 5',
            facilityAddress: {
                address1: '250 Broadway, New York, NY, 10016, USA',
            },
        },
        {
            facilityId: 67893,
            facilityName: 'Facility 6',
            facilityAddress: {
                address1: '789 Fifth Avenue, New York, NY, 10017, USA',
            },
        },
        {
            facilityId: 78904,
            facilityName: 'Facility 7',
            facilityAddress: {
                address1: '456 Madison Avenue, New York, NY, 10018, USA',
            },
        },
        {
            facilityId: 89015,
            facilityName: 'Facility 8',
            facilityAddress: {
                address1: '123 Park Avenue, New York, NY, 10019, USA',
            },
        },
        {
            facilityId: 90126,
            facilityName: 'Facility 9',
            facilityAddress: {
                address1: '678 Lexington Avenue, New York, NY, 10020, USA',
            },
        },
        {
            facilityId: 10237,
            facilityName: 'Facility 10',
            facilityAddress: {
                address1: '345 Third Avenue, New York, NY, 10021, USA',
            },
        },
        {
            facilityId: 11348,
            facilityName: 'Facility 11',
            facilityAddress: {
                address1: '567 Second Avenue, New York, NY, 10022, USA',
            },
        },
        {
            facilityId: 12459,
            facilityName: 'Facility 12',
            facilityAddress: {
                address1: '890 First Avenue, New York, NY, 10023, USA',
            },
        },
        {
            facilityId: 13560,
            facilityName: 'Facility 13',
            facilityAddress: {
                address1: '234 Seventh Avenue, New York, NY, 10024, USA',
            },
        },
        {
            facilityId: 14671,
            facilityName: 'Facility 14',
            facilityAddress: {
                address1: '456 Eighth Avenue, New York, NY, 10025, USA',
            },
        },
        {
            facilityId: 15782,
            facilityName: 'Facility 15',
            facilityAddress: {
                address1: '678 Ninth Avenue, New York, NY, 10026, USA',
            },
        },
        {
            facilityId: 16893,
            facilityName: 'Facility 16',
            facilityAddress: {
                address1: '890 Tenth Avenue, New York, NY, 10027, USA',
            },
        },
        {
            facilityId: 17904,
            facilityName: 'Facility 17',
            facilityAddress: {
                address1: '123 Eleventh Avenue, New York, NY, 10028, USA',
            },
        },
        {
            facilityId: 18015,
            facilityName: 'Facility 18',
            facilityAddress: {
                address1: '345 Twelfth Avenue, New York, NY, 10029, USA',
            },
        },
        {
            facilityId: 19126,
            facilityName: 'Facility 19',
            facilityAddress: {
                address1: '567 Amsterdam Avenue, New York, NY, 10030, USA',
            },
        },
        {
            facilityId: 20237,
            facilityName: 'Facility 20',
            facilityAddress: {
                address1: '789 Columbus Avenue, New York, NY, 10031, USA',
            },
        },
        {
            facilityId: 21348,
            facilityName: 'Facility 21',
            facilityAddress: {
                address1: '901 Central Park West, New York, NY, 10032, USA',
            },
        },
    ]
}
